import React from "react";
import "../Styles/MedicalTranscription.css";
import mt1Img from "../Assets/service1.png";
import mt2Img from "../Assets/service2.png";
function MedicalTranscription() {
  return (
    <div className="mt-cover">
      <div className="mt-head">
        <h1
          className="mt-h1"
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          MEDICAL TRANSCRIPTION SERVICES
        </h1>
        <hr />
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Medical Transcription (MT) is amanual process for voice recorded
          filesdictated by doctors and other healthcare professionals into text
          format. Transcriptionists play a vital role for healthcare providers
          who voice-record their notes, they convert voice files into text or in
          digital format. Using electronic data have become essential to comply
          with Health IT and Electronic Health Record (HER)
          programs.Occasionally, voice streaming is used so that voice files can
          reach the MT section for immediate transcription.
        </p>
        <div
          className="mt-head-img"
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          <img src={mt1Img} alt="Medical Transcription Services" />
        </div>
      </div>
      <div
        className="mt-head-below"
        data-aos="zoom"
        data-aos-duration="500"
        data-aos-easing="ease-in-out"
      >
        <h2>Medical Transcription Services</h2>
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Get your medical documents transcribed by dedicated and experienced
          transcriptionists with vast expertise in the medical domain at prices
          starting at $4/read
        </p>
        <br />
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Are you falling short of trained and experienced medical
          transcriptionists for your medical organization? Are you unable to
          focus on your core activities and patient care as medical
          transcription is taking too much of your time? Then, the right step
          for your organization would be to outsource medical transcription
          services to an experienced service provider. By outsourcing, you will
          not only have access to experienced resources but also be able to
          focus on your core activities.
        </p>
        <br />
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Clinics4Health is one such medical transcription service providing
          company who can be your one-stop-shop for all your medical
          transcription requirements. Our team comprises of some of the most
          skilled and experienced individuals who can cater to any of the
          client’s needs. Outsourcing medical transcription to us can help you
          focus better on patient care and provide your clients with the best
          customer service.
        </p>
      </div>
      <br />
      <div
        className="mt-third"
        data-aos="zoom"
        data-aos-duration="500"
        data-aos-easing="ease-in-out"
      >
        <h2>Medical Transcription Services We Offer</h2>
        <p>
          Having been in the healthcare industry for over 16 years now, we
          understand the client’s requirements with ease and provide the
          services accordingly. We leverage the best infrastructure and the
          latest tools and technologies to deliver the best quality
          transcription services. Some of the key medical transcription services
          we offer include –
        </p>
        <div className="mt-table1">
          <div className="mt-table-col1">
            <ul>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>EMR Transcription Services</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Surgery Transcription</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Ophthalmology Transcription Services</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Patient charts</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Teleconference notes</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Clinical summary</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>History and physical reports</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Medical records summary</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Progress notes</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Pediatric/Geriatric reports</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Rehabilitation reports</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>SOAP notes</h3>
              </li>
            </ul>
          </div>
          <div className="mt-table-col2">
            <ul>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Neurology Transcription</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Radiology Transcription</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Discharge summary</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Oncology Reports</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Pathology Reports</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>HL7 Reports</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Dermatology Transcription</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Medical Reports</h3>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <h3>Psychiatry Reports</h3>
              </li>
              <li>
                <h3>Emergency room reports</h3>
              </li>
              <li>
                <h3>Operative Reports Transcription Services</h3>
              </li>
              <li>
                <h3>ENT Transcription Services</h3>
              </li>
              <li>
                <h3>Cardiology Transcription Services</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-fourth">
        <h2
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          The Medical Transcription Team at Clinics4Health
        </h2>
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Our teams are located across different geographical locations – India,
          The Philippines, Kenya, and South America. Before they start work, our
          medical transcriptionists undergo rigorous training that covers
          different specialties. Our medical transcription team includes the
          following –
        </p>
        <div>
          <ul
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            <li>
              <h4>Client Account Managers</h4>
            </li>
            <li>
              <h4>Tier-1 Transcriptionists</h4>
            </li>
            <li>
              <h4>Quality Assurance Associates</h4>
            </li>
            <li>
              <h4>Proof-readers and Editors</h4>
            </li>
          </ul>
        </div>
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Dedicated medical transcriptionists work on each client account. This
          helps ensure that they are well versed with the dictating physician’s
          style and accent. This approach also helps us deliver consistently
          superior services.
        </p>
        <h2
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Software We Leverage for Medical Transcription Services
        </h2>
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Being one of the leading providers of medical transcription services,
          we believe in providing the best quality services within a quick time.
          This is made possible by making use of the best and the latest medical
          transcription tools and technologies. Some of the key tools and
          technologies we leverage include –
        </p>
        <h2
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Medical Transcription Process at Clinics4Health
        </h2>
        <p
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          Clinics4Health adheres to a robust process to ensure that the final
          output is of superior quality. The following steps capture the way in
          which we work –
        </p>
        <div>
          <ul>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <p>
                The Account Manager retrieves the dictations from the FTP or
                client-server. These are then assigned to the designated Tier-1
                transcriptionist who works as a dedicated resource for you
              </p>
            </li>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <p>
                The medical transcriptionists use prescribed templates to
                transcribe the audio. Then, they submit the completed document
                for proofreading
              </p>
            </li>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <p>
                The proofreaders check the transcripts for any grammatical
                mistakes. The reviewed and corrected documents are sent to the
                Quality Assurance (QA) team. Feedback is sent to the Tier-1 team
              </p>
            </li>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <p>
                The QA team uses random sampling to perform quality checks. They
                send their review comments to both the transcriptionists and the
                proofreaders
              </p>
            </li>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <p>
                In the end, the completed medical transcriptions are sent to the
                Account Manager who does a final check to ensure that the
                correct templates have been used. Once this is done, the final
                documents are sent to the client
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-img-section">
        <div className="mt-img-left">
          <h2
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            Why Choose Clinics4Health for Medical Transcription Services?
          </h2>
          <p>
            Outsourcing medical transcription services can help you get access
            to a series of benefits that you can take advantage of. Some of the
            key reasons for you to choose us include –
          </p>
          <ul>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>Access to skilled medical transcriptionists</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Our medical transcriptionists undergo a rigorous six-month medical
              transcription course before they start working for clients. We
              also have physiotherapists and other therapists that are well
              versed in medical terminology on our team.
            </p>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>Get access to superior quality services</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Our three-tier process ensures that each file is checked for
              quality before it is submitted to the client. This means that you
              get 99% defect-free work. In addition, we ensure that
              transcriptionists that have extensive experience in that
              particular specialty are assigned to work on a specific client
              account. This means that you can be assured that all medical
              terminologies will be correctly transcribed. Also, we check each
              transcript – from the template to the patient details to the
              dictation – twice for accuracy.
            </p>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>Turnaround of work in less than 24 hours</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Since our delivery centers are in the Philippines and India, our
              North American customers can take advantage of the overnight
              turnaround time. With us, you can get reports back faster than
              ever before.
            </p>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>Access 100% HIPAA compliant services</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Partnering with us gives you access to a committed team that has
              undergone HIPAA training. We ensure that our healthcare processes
              are 100% complaint.
            </p>
            <li>
              <h3>Ensure that quality is optimized</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Our workflow is designed to ensure that you get defect-free work.
              Our QA team checks the final output and corrects any grammatical
              and contextual errors.
            </p>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>
                Get the delivery of your files in your preferred format to
                software or destination that you choose: We can deliver the
                final transcripts in any of the following ways –
              </h3>
            </li>
            <ul>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <p>By faxing copies directly to your physicians</p>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <p>
                  By transcribing directly into your medical records software
                </p>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <p>By printing on-site at your facility</p>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <p>
                  Through the import of documents directly into your medical
                  records
                </p>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <p>Using scheduled e-mail delivery</p>
              </li>
              <li
                data-aos="zoom"
                data-aos-duration="500"
                data-aos-easing="ease-in-out"
              >
                <p>Using secure Internet download via HTTPS and FTP</p>
              </li>
              <li>
                <p>
                  By importing documents directly into your medical
                  records/hospital software
                </p>
              </li>
            </ul>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>Sign up for a FREE Trial</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              You can send us sample audio files and transcripts to work on.
              This trial run can help you gauge our capabilities as a trusted
              outsourcing vendor.
            </p>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>Dedicated Project Manager</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              We will assign a dedicated project manager when you choose to
              outsource medical transcription services to us. The manager will
              always keep you updated about the project status and resolve any
              issues that you may have.
            </p>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>24/7 Availability</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              We provide our clients with round the clock support. All our team
              including the sales teams, project managers, and call center
              executives are always available via phone or email.
            </p>
            <li
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <h3>Data Security</h3>
            </li>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              We take data security very seriously. We are an ISO/IEC/ ISMS
              certified organization which ensures that all your patient-related
              data is completely safe with us.
            </p>
          </ul>
        </div>
        <div
          className="mt-img-right"
          data-aos="zoom"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          <img src={mt2Img} alt="Medical Transcription Services" />
        </div>
      </div>
    </div>
  );
}

export default MedicalTranscription;
